import { anyPass, equals, isEmpty, map, not } from 'ramda';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Color } from '../../../constants/Color';
import { grayBorderStyle, Row } from './ColorsFilter.constants';
import { IOuter } from './ColorsFilter.types';
import { AnyColorFilterNode } from './AnyColorFilterNode';
import { BlackWhiteColorsFilterNode } from './BlackWhiteColorsFilterNode';
import { ColorFilterNode } from './ColorFilterNode';
import { ColorFilterRow } from './ColorFilterRow';

const checkIfRowColorSelected = (selectedColor, rowType) => {
  switch (rowType) {
    case Row.AnyColor:
      return equals(selectedColor, Color.Any);

    case Row.BlackWhite:
      return equals(selectedColor, Color.BlackWhite);

    default:
      return not(anyPass([equals(Color.Any), equals(Color.BlackWhite)])(selectedColor));
  }
};

export const ColorsFilter: FC<IOuter> = ({
  isAnyColorFilterVisible = true,
  isBlackWhiteFilterVisible = true,
  customColors = [],
  selectedColor,
  onColorSelect,
}) => (
  <table>
    <tbody>
      {isAnyColorFilterVisible && (
        <ColorFilterRow
          label={<FormattedMessage id="filter.color.label.all-colors" />}
          colors={
            <AnyColorFilterNode
              isSelected={equals(selectedColor, Color.Any)}
              onClick={onColorSelect(Color.Any)}
              key="any-colors-filter-node"
            />
          }
          isActive={checkIfRowColorSelected(selectedColor, Row.AnyColor)}
          dataHook="colors-filter-any-colors-row"
        />
      )}

      {isBlackWhiteFilterVisible && (
        <ColorFilterRow
          label={<FormattedMessage id="filter.color.label.black-white-colors" />}
          colors={
            <BlackWhiteColorsFilterNode
              isSelected={equals(selectedColor, Color.BlackWhite)}
              onClick={onColorSelect(Color.BlackWhite)}
              key="black-white-colors-filter-node"
            />
          }
          isActive={checkIfRowColorSelected(selectedColor, Row.BlackWhite)}
          dataHook="colors-filter-black-white-colors-row"
        />
      )}

      {not(isEmpty(customColors)) && (
        <ColorFilterRow
          label={<FormattedMessage id="filter.color.label.custom-colors" />}
          labelVerticalAlignment="top"
          colors={
            <>
              {map(
                (color) => (
                  <ColorFilterNode
                    color={color}
                    innerCircleStyle={equals(color, Color.White) ? grayBorderStyle : {}}
                    onClick={onColorSelect(color)}
                    isSelected={equals(selectedColor, color)}
                    key={color}
                  />
                ),
                customColors,
              )}
            </>
          }
          isActive={checkIfRowColorSelected(selectedColor, Row.CustomColor)}
          dataHook="colors-filter-custom-colors-row"
        />
      )}
    </tbody>
  </table>
);
